import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

export function ModalCloseButton() {
  return (
    <IconButton aria-label="close" size="small" className="modal-close-button">
      <CloseIcon fontSize="small" />
    </IconButton>
  );
}
